import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var getInputSkeletonQuery = function getInputSkeletonQuery() {
  var _window;
  return ((_window = window) === null || _window === void 0 || (_window = _window.inputSkeletonState) === null || _window === void 0 ? void 0 : _window.query) || '';
};
var setInputSkeletonQuery = function setInputSkeletonQuery(newQuery) {
  var _window2;
  if ((_window2 = window) !== null && _window2 !== void 0 && _window2.inputSkeletonState) {
    window.inputSkeletonState.query = newQuery;
  }
};
var getInputSkeletonFocus = function getInputSkeletonFocus() {
  var _window3;
  return ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.inputSkeletonState) === null || _window3 === void 0 ? void 0 : _window3.isFocused) || false;
};
var setInputSkeletonIsFocus = function setInputSkeletonIsFocus(newIsFocused) {
  var _window4;
  if ((_window4 = window) !== null && _window4 !== void 0 && _window4.inputSkeletonState) {
    window.inputSkeletonState.isFocused = newIsFocused;
  }
};
var getInputSkeletonSelection = function getInputSkeletonSelection() {
  var _window5, _window6, _window7;
  var selectionStart = ((_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.inputSkeletonState) === null || _window5 === void 0 ? void 0 : _window5.selectionStart) || 0;
  var selectionEnd = ((_window6 = window) === null || _window6 === void 0 || (_window6 = _window6.inputSkeletonState) === null || _window6 === void 0 ? void 0 : _window6.selectionEnd) || 0;
  var selectionDirection = ((_window7 = window) === null || _window7 === void 0 || (_window7 = _window7.inputSkeletonState) === null || _window7 === void 0 ? void 0 : _window7.selectionDirection) || 'none';
  return {
    selectionStart: selectionStart,
    selectionEnd: selectionEnd,
    selectionDirection: selectionDirection
  };
};
var setInputSkeletonSelection = function setInputSkeletonSelection(newSelectionStart, newSelectionEnd, newSelectionDirection) {
  var _window8;
  if ((_window8 = window) !== null && _window8 !== void 0 && _window8.inputSkeletonState) {
    window.inputSkeletonState.selectionStart = newSelectionStart;
    window.inputSkeletonState.selectionEnd = newSelectionEnd;
    window.inputSkeletonState.selectionDirection = newSelectionDirection;
  }
};
var resetInputSkeletonState = function resetInputSkeletonState() {
  window.inputSkeletonState = {
    query: '',
    placeholder: '',
    isFocused: false,
    selectionStart: 0,
    selectionEnd: 0,
    selectionDirection: 'none',
    listeners: []
  };
};
var removeInputSkeletonEventListeners = function removeInputSkeletonEventListeners() {
  if (window.inputSkeletonState) {
    window.inputSkeletonState.listeners.forEach(function (ssrEventListener) {
      var _ssrEventListener = _slicedToArray(ssrEventListener, 3),
        target = _ssrEventListener[0],
        event = _ssrEventListener[1],
        handler = _ssrEventListener[2];
      target.removeEventListener(event, handler);
    });
    window.inputSkeletonState.listeners = [];
  }
};
var removeInputSkeletonState = function removeInputSkeletonState() {
  if (window['inputSkeletonState']) {
    removeInputSkeletonEventListeners();
    delete window['inputSkeletonState'];
  }
};
export { getInputSkeletonQuery, setInputSkeletonQuery, getInputSkeletonFocus, setInputSkeletonIsFocus, getInputSkeletonSelection, setInputSkeletonSelection, resetInputSkeletonState, removeInputSkeletonEventListeners, removeInputSkeletonState };